import React from "react";
import { setLocale } from "yup";
import { ToastContainer } from "react-toastify";
import { AppProvider } from "./src/hooks/appContext";
import Layout from "./src/features/marketing/Layout";
import ensureEnv from "./src/utils/ensureEnv";
import "react-toastify/dist/ReactToastify.css";
import { CartProvider } from "./src/hooks/cartContext";
import MDXProviderWrapper from "./src/components/MDXProviderWrapper";

setLocale({
  mixed: {
    required: "Required",
  },
  string: {
    email: "Invalid email address",
  },
});

function wrapRootElement({ element }) {
  return (
    <MDXProviderWrapper>
      <AppProvider
        stripeKey={ensureEnv("GATSBY_STRIPE_KEY", process.env.GATSBY_STRIPE_KEY)}
        cleverClientId={ensureEnv(
          "GATSBY_CLEVER_CLIENT_ID",
          process.env.GATSBY_CLEVER_CLIENT_ID
        )}
        googleClientId={ensureEnv(
          "GATSBY_GOOGLE_CLIENT_ID",
          process.env.GATSBY_GOOGLE_CLIENT_ID
        )}
        classWalletVendorId={ensureEnv(
          "GATSBY_CLASS_WALLET_VENDOR_ID",
          process.env.GATSBY_CLASS_WALLET_VENDOR_ID
        )}
        apiBaseUrl={ensureEnv(
          "GATSBY_API_URL",
          process.env.GATSBY_API_URL
        )}
      >
        <CartProvider>
          {element}
        </CartProvider>
      </AppProvider>
    </MDXProviderWrapper>
  );
}

function wrapPageElement({ element }) {
  return (
    <Layout>
      {element}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover
        theme="colored"
      />
    </Layout>
  );
}

export { wrapRootElement, wrapPageElement };